import React from "react";
import styled from "styled-components";
import { mediaQueries } from "../theme";

export const HeaderImage = styled.div`
  position: relative;
  height: 500px;
  background-image: url("/image_emotion_paysage.png");
  background-repeat: no-repeat;
  background-size: cover;
  ::before {
    position: absolute;
    top: calc((100% - 200px) / 2);
    font-size: 30px;
    z-index: 100;
    padding: 20px;
    content: "Une plateforme qui vous rapproche de vos célébrités.";
    text-align: center;
    display: block;
    width: 100%;
    height: 250px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    ${mediaQueries.desktop} {
      width: 600px;
      height: 200px;
      left: calc((100% - 600px) / 2);
      font-size: 40px;
    }
  }
`;
